import React, { useContext, useEffect, useState } from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Trans, useTranslation } from 'react-i18next';
import { Avatar, Box, Button, Checkbox, FormLabel, Typography } from '@mui/material';
import { getMediaLogo } from '../../utils/file';
import { IPackageCard } from '../../interfaces/campaign';
import { formatPricePersian } from '../../utils/number';
import { CampaignContext } from '../../contexts/CampaignContext';

const PackageCard: React.FC<IPackageCard> = ({ id, title, entities_count, followers_count, price, image, media, onSelect, setShowPages }) => {
	const { t } = useTranslation();
	const [isChecked, setIsChecked] = useState(false);

	const { selectedPackages, viewSelectedItemsMode } = useContext(CampaignContext);

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		setIsChecked(checked);
		if (onSelect) {
			const data = { id, entities_count, followers_count, image, media, price, title };
			onSelect(data, checked);
		}
	};

	const _price = formatPricePersian(price);
	const pagesCount = entities_count?.toString();

	useEffect(() => {
		setIsChecked(selectedPackages.some(pkg => pkg.id === id));
	}, [selectedPackages, id]);

	const handleShowPage = () => {
		if (setShowPages !== undefined) {
			setShowPages(id);
		}
	};

	return (
		<Box className="relative flex w-64 flex-col items-center justify-center rounded-2xl border border-grey-300 p-4">
			<Avatar src={getMediaLogo(media)} alt="platform img" className="absolute right-3 top-3 h-12 w-12" />
			<Avatar src={image} alt="package img" className="mb-4 h-28 w-28" />
			<Box className="flex w-full items-center justify-start border-b py-2">
				<Checkbox size="large" className="me-2 p-0 text-grey-400" checked={isChecked} onChange={handleCheckboxChange} disabled={viewSelectedItemsMode} />
				<FormLabel className="text-base font-medium text-text-primary">{title}</FormLabel>
			</Box>
			<Box className="flex w-full items-center justify-between border-b pb-2 pt-3">
				<Box className="flex items-center">
					<GroupsIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('pages_count')}</Typography>
				</Box>
				<Trans i18nKey="pages_count_value" values={{ pagesCount }} components={[<Typography className="text-sm font-medium text-text-primary" />]} />
			</Box>
			<Box className="flex w-full items-center justify-between pb-2 pt-3">
				<Box className="flex items-center">
					<AccountBalanceWalletIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('price')}</Typography>
				</Box>
				<Trans i18nKey="tooman_amount_label" values={{ amount: _price }} components={[<Typography className="text-sm font-medium text-text-primary" />]} />
			</Box>
			<Button variant="outlined" className="mt-2 w-full" onClick={handleShowPage}>
				{t('view_pages')}
			</Button>
		</Box>
	);
};

export default PackageCard;
